// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sec2[data-v-7c7b4fc2]{margin-top:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
